{
  "codeExpired": "The code you entered is expired.",
  "codeInvalid": "The code you entered is invalid. Please double-check and try again.",
  "decimalNumber": "This field must be a number.",
  "deviceLocationUnknown": "Device location unknown.",
  "integerOnly": "This field must be a whole number.",
  "maxLengthWithVal": "Too many characters ({{val}} maximum)",
  "maxValueWithVal": "This value must be less than or equal to {{val}}.",
  "minLength": "must be at least {{minLength}} characters.",
  "minValueWithVal": "This value must be at least {{val}}.",
  "passwordRulesLowercaseCount": "Password must contain at least one lowercase letter.",
  "passwordRulesMinLength": "Password must be at least 8 characters long.",
  "passwordRulesMustMatch": "Passwords must match.",
  "passwordRulesNumericCount": "Password must contain at least one number.",
  "passwordRulesSpecialCharacterCount": "Password must contain at least one special character (!@#$$^&*)",
  "passwordRulesUppercaseCount": "Password must contain at least one uppercase letter.",
  "required": "This field is required."
}
